import React from 'react';
import { useAllReceivedChangeRequestsQuery } from '../../../__generated__/graphql';
import ServerError from '../../../../../components/ServerError';
import { mapReceivedShiftChangeRequests } from './mappings';
import { ReceivedShiftChangeRequestsTable } from './ReceivedShiftChangeRequestsTable';

export const ReceivedShiftChangeRequests: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { data, loading, error } = useAllReceivedChangeRequestsQuery({});

  if (error) {
    return <ServerError />;
  }

  const requests = mapReceivedShiftChangeRequests(
    data?.me.shiftChangeRequestsToMe ?? [],
  );

  return (
    <ReceivedShiftChangeRequestsTable requests={requests} loading={loading} />
  );
};
